<template>
  <QLayout view="lhr lpr lfr">
    <QHeader bordered class="header justify-center">
      <Header />
    </QHeader>

    <QPageContainer class="container">
      <QPage class="flex column">
        <div class="col-grow">
          <router-view />
        </div>
      </QPage>
    </QPageContainer>

    <QFooter>
      <Footer :twoColumn="false" />
    </QFooter>
  </QLayout>
</template>
<script>
import { QLayout, QPage, QHeader, QFooter, QPageContainer } from 'quasar';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

/**
 * This component defines a common page layout with slots for:
 * - A Header
 * - A Menu
 * - A Footer
 */
export default {
  name: 'HomeLayout',
  data() {
    return {
      menuOpen: true,
      menuMini: true
    };
  },
  mounted() {
    // Define a closeMenu receiver as we can not capture emits from slots
    this.$on('closeMenu', () => (this.menuMini = true));
  },
  components: {
    QLayout,
    QPage,
    QHeader,
    QFooter,
    QPageContainer,
    Header,
    Footer
  }
};
</script>

<style lang="sass" scoped>
.q-tooolbar
  min-height: 36px;
.q-header
  background: #FFFFFF;
.header
  padding: 5px 0;
.q-header--bordered
  border-bottom: 1px solid #EDEDED;
</style>
